import { ButtonBase, Divider, Typography } from '@mui/material'
import { ActionText, Tag } from 'components/atoms/Text'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { Trans, useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import { getPercentageDisplay } from 'utils/formatText'

export const MAX_ATTEMPTS = 4
export const PASS_PERCENTAGE = 0.6

const AnswersTag = ({
  index,
  selectedIndex,
  setSelectedIndex,
  score,
  passed
}) => {
  const { t } = useTranslation()
  const selected = selectedIndex === index
  const backgroundColor = passed
    ? selected
      ? colors.Green200
      : colors.Green100
    : colors.Peach100
  const borderColor = passed ? colors.Green300 : colors.Peach400

  return (
    <ButtonBase
      onClick={() => setSelectedIndex(index)}
      disabled={selectedIndex === null}
      sx={{
        backgroundColor,
        borderRadius: 2,
        borderWidth: 2,
        padding: 4,
        outline: selected ? `2px dashed ${borderColor}` : 'none',
        outlineOffset: '-2px'
      }}>
      <RowStack spacing={2}>
        <Typography variant='buttonSmall' textTransform='uppercase'>
          {t(`stepQuiz.attemptOrdinal.${index}`)}
        </Typography>
        <Typography variant='h3' lineHeight={'110%'}>
          {getPercentageDisplay(score)}
        </Typography>
      </RowStack>
    </ButtonBase>
  )
}

export const AttemptsBanner = ({
  answersArray,
  displayAnswerIndex,
  setDisplayAnswerIndex,
  passed,
  fullScore,
  handleRetake
}) => {
  const { t } = useTranslation()
  const maxScore = Math.max(...answersArray.map(a => a.score))
  const attemptsLeft = MAX_ATTEMPTS - answersArray?.length
  const displayMessage =
    fullScore || (passed && answersArray?.length === MAX_ATTEMPTS) ? (
      <Trans
        i18nKey='stepQuiz.passedQuizClosed'
        values={{ score: getPercentageDisplay(maxScore) }}
      />
    ) : passed ? (
      <Trans i18nKey='stepQuiz.passedMoreAttempt' values={{ attemptsLeft }} />
    ) : attemptsLeft > 0 ? (
      <Trans i18nKey='stepQuiz.failedMoreAttempt' values={{ attemptsLeft }} />
    ) : (
      t('stepQuiz.failedQuizClosed', { score: getPercentageDisplay(maxScore) })
    )
  return (
    <>
      <BoxWithBackground
        width='100%'
        padding={6}
        borderRadius={2}
        backgroundColor={
          displayAnswerIndex !== null
            ? passed
              ? colors.Green50
              : colors.Peach50
            : colors.Grey25
        }>
        <ColStack spacing={4}>
          <RowStack justifyContent='space-between'>
            <RowStack spacing={4}>
              {answersArray?.length ? (
                answersArray.map((a, i) => (
                  <AnswersTag
                    key={`answer-tage-${i}`}
                    index={i}
                    passed={a.score >= PASS_PERCENTAGE}
                    score={a.score}
                    selectedIndex={displayAnswerIndex}
                    setSelectedIndex={setDisplayAnswerIndex}
                  />
                ))
              ) : (
                <Typography>
                  {t('stepQuiz.neededToPass', {
                    percentage: getPercentageDisplay(PASS_PERCENTAGE)
                  })}
                </Typography>
              )}
            </RowStack>
            <Tag sx={{ minWidth: 'fit-content' }}>
              {fullScore || attemptsLeft === 0
                ? t('stepQuiz.learningCheckClosed')
                : t('stepQuiz.mOfNAttempts', {
                    m: t(
                      `stepQuiz.attemptOrdinal.${displayAnswerIndex === null ? answersArray.length : displayAnswerIndex}`
                    ),
                    n: MAX_ATTEMPTS
                  })}
            </Tag>
          </RowStack>
          {displayAnswerIndex !== null && (
            <Typography variant='body1Small'>
              {displayMessage}
              {!passed && attemptsLeft > 0 && (
                <ActionText
                  variant='body1Small'
                  sx={{ textDecoration: 'underline' }}
                  fontWeight='bold'
                  onClick={() => handleRetake()}>
                  {t('stepQuiz.tryAgainNow')}
                </ActionText>
              )}
            </Typography>
          )}
        </ColStack>
      </BoxWithBackground>
      <Divider width='100%' />
    </>
  )
}
